import React, { useRef } from 'react';
import { ContactForm } from '../pages/contact/ContactForm';
import styles from './Modal.module.scss';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Terms } from '../pages/terms/Terms';
import BookingForm from '../pages/rejestracja/BookingDialog';
import SignFormConfirmation from '../pages/rejestracja/SignFormConfirmation';

const Modal = () => {
  const modalRef = useRef();
  const { lang, id, slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const renderModal = (id) => {
    switch (id) {
      case 'contact':
        return <ContactForm />;
      case 'terms':
        return <Terms />;
      case 'register':
      case 'rejestracja':
        // return (
        //   <img
        //     src={require('../../images/formClosed.jpg')}
        //     style={{
        //       width: '100%',
        //       height: 'auto',
        //       objectFit: 'contain',
        //     }}
        //     alt='booking form closed'
        //   />
        // );
        return slug === 'success' ? (
          <SignFormConfirmation />
        ) : (
          <BookingForm setOpen={true} />
        );
      default:
        console.warn('Unknown modal slug:', id);
        return null;
    }
  };
  return (
    <div
      ref={modalRef}
      onClick={() =>
        // id !== 'rejestracja' &&
        navigate(`/${lang}`, { state: { from: location } })
      }
      className={styles.modalWrapper}
    >
      <div onClick={(e) => e.stopPropagation()} className={styles.inner}>
        {renderModal(id)}
      </div>
    </div>
  );
};

export default Modal;
